import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { fetchOrganization } from '../../actions/authActions';

const Branding = WrappedComponent => {
  function VisitorCustomBranding(props) {
    const dispatch = useDispatch();
    const organization = useSelector(state => state.auth.organization);
    const urlDomain = window.location.hostname.split('.')[0];
    const [visitorOrg, setVisitorOrg] = useState({});

    useEffect(() => {
      let unmounted = false;
      if (!unmounted) {
        dispatch(fetchOrganization(urlDomain));
      }
      return () => {
        unmounted = true;
      };
    }, []);

    useEffect(
      () => {
        if (!!organization && organization.id && !!organization.branding_theme) {
          const accentColor = _get(organization, 'branding_theme.themes.theme_color_accent') || '#dd2160';
          const darkColor = _get(organization, 'branding_theme.themes.theme_color_dark') || '#043544';
          const lightColor = _get(organization, 'branding_theme.themes.theme_color_light') || '#76ccce';
          document.documentElement.style.setProperty('--theme_color_dark', darkColor);
          document.documentElement.style.setProperty('--theme_color_accent', accentColor);
          document.documentElement.style.setProperty('--theme_color_light', lightColor);

          setVisitorOrg(organization);
        }
      },
      [props],
    );

    return (
      <>
        <WrappedComponent {...props} visitorOrg />;
      </>
    );
  }
  return VisitorCustomBranding;
};
export default Branding;
